import Toast from "../../common/components/ui/toast";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import Dashboard from "../../common/components/layout/Dashboard";
import { SupplierDashboardProvider } from "./components/supplier-dashboard/SupplierDashboard.provider";
import { useParams } from "react-router-dom";
import { SupplierDashboard } from "./components/supplier-dashboard";

export default function SuppliersDetailsPage() {
  const { supplierId } = useParams()

  return (
    <ToastProvider>
      <Dashboard>
        <SupplierDashboardProvider supplierId={supplierId || ''}>
          <SupplierDashboard />
        </SupplierDashboardProvider>
      </Dashboard>
      <Toast />
    </ToastProvider>
  )
}

